<template>
    <div class="profile-common__circle-counter" :data-testid="dataTestid" :data-counter-percentage="props.completionPercentage">
        <svg width="30" height="30">
            <circle
                class="profile-common__circle-counter__circle-base"
                stroke="grey"
                stroke-width="4"
                fill="transparent"
                r="10"
                cx="15"
                cy="15"
                :data-testid="`${dataTestid}-circle-base`"
            />
            <circle
                ref="progressCircleCreation"
                class="profile-common__circle-counter__circle-progress"
                :stroke="props.color"
                stroke-width="4"
                fill="transparent"
                r="10"
                cx="15"
                cy="15"
                :style="strokePropertiesForCompletion"
                :data-testid="`${dataTestid}-circle-progress`"
            />
        </svg>
    </div>
</template>

<script lang="ts" setup>
    import {computed, useTemplateRef} from 'vue';

    type Props = {
        dataTestid?: string;
        completionPercentage?: number;
        color?: string;
    };
    const props = withDefaults(defineProps<Props>(), {
        dataTestid: 'profile-common-circle-counter',
        completionPercentage: 0,
        color: 'var(--joy-color-tertiary-50)',
    });

    const progressCircleCreation = useTemplateRef('progressCircleCreation');

    type StrokeProperties = {
        'stroke-dasharray': string;
        'stroke-dashoffset': string;
    };

    const strokePropertiesForCompletion = computed((): StrokeProperties => {
        return calculateStrokeProperties(10, props.completionPercentage);
    });

    function calculateStrokeProperties(radius: number, percentage: number): StrokeProperties {
        const circumference = radius * 2 * Math.PI;
        const offset = circumference - (percentage / 100) * circumference;

        return {
            'stroke-dasharray': `${circumference} ${circumference}`,
            'stroke-dashoffset': `${offset}`,
        };
    }
</script>

<style lang="scss">
    .profile-common__circle-counter {
        height: 30px;

        &__circle {
            &-base,
            &-progress {
                transition: var(--joy-transition-duration-long) stroke-dashoffset;
                transform: rotate(-90deg);
                transform-origin: 50% 50%;
            }

            &-base {
                stroke: var(--joy-color-neutral-30);
            }
        }
    }
</style>
